module.exports = __webpack_public_path__ + "img/logo-gulp.42583119.png";